import { prepareSortedOptions } from '../../prepareOptions';
import {
  ELECTRIC_HEATED_SEATS,
  ELECTRIC_SIDE_MIRROR,
  ELECTRIC_WINDOWS,
  HEAD_UP_DISPLAY,
  ISOFIX,
  MULTIFUNCTION_STEERING_WHEEL,
  ON_BOARD_COMPUTER,
} from './values';

export default prepareSortedOptions([
  {
    value: ON_BOARD_COMPUTER,
    label: __('carDetails.equipmentGroups.onBoardComputer'),
  },
  {
    value: ELECTRIC_HEATED_SEATS,
    label: __('carDetails.equipmentGroups.heatedSeats'),
  },

  {
    value: ELECTRIC_SIDE_MIRROR,
    label: __('carDetails.equipmentGroups.sideViewMirrors'),
  },
  {
    value: ELECTRIC_WINDOWS,
    label: __('carDetails.equipmentGroups.heatedFrontWindow'),
  },
  {
    value: HEAD_UP_DISPLAY,
    label: __('carDetails.equipmentGroups.headUpDisplay'),
  },
  {
    value: ISOFIX,
    label: __('carDetails.equipmentGroups.childSeatsIsofixMountingPoints'),
  },

  {
    value: MULTIFUNCTION_STEERING_WHEEL,
    label: __('carDetails.equipmentGroups.steeringWheel'),
  },
]);
